
import Vue from 'vue'
import type { PropType } from 'vue'

interface LinkItem {
  title: string;
  code: string;
  children: LinkItem[];
  isUrl?: boolean;
}

export default Vue.extend({
  name: 'TopHeaderMenu',
  props: {
    /**
     * Массив деревьев ссылок
     */
    sections: {
      type: Array as PropType<LinkItem[]>,
      required: true,
      default: () => []
    },
    /**
     * Код текущего корневого роута
     */
    currentRouteCode: {
      type: String,
      required: true,
      default: ''
    }
  },
  computed: {
    visibleLinks () {
      return this.sections?.slice(0, 3) || []
    },
    hiddenLinks () {
      return this.sections?.slice(3)
    }
  }
})
